import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-goto-cratdialog',
  templateUrl: './goto-cratdialog.component.html',
  styleUrls: ['./goto-cratdialog.component.scss']
})
export class GotoCratdialogComponent implements OnInit {

  title: string = "Are you sure you want to delete ?";
  ok: boolean = false;
  isClose: boolean = false;
  cartId:any;
  cartProducts:any
  organizationID:any;

 
  constructor(   private router: Router,public dialogRef: MatDialogRef<GotoCratdialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any) {


       

      if(_data && _data.title) {
        this.title = _data.title;
      }
      if (_data.ok) {
        this.ok = true;
      }
      if(_data.isClose) {
        this.isClose = _data.isClose;
      }
      if(_data.cart_id){
        this.cartId = _data.cart_id

      }

      this.organizationID =  _data.organization_id

       
      this.cartProducts = _data.cart_products;

      this.cartProducts.forEach(element => {
         
        element.product_data  = JSON.parse(element.product_data)
      });

      console.log(this.cartProducts , "testtt" );
      
   }

  ngOnInit() {
  }

  close(type): void {
    this.dialogRef.close(type);
  }
  gotoCheckout()
  {
    
  this.router.navigateByUrl('/network-market/product-cart/'+this.cartId);
  this.dialogRef.close();
  }

}
